import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { LayerInfo } from '@root/search/models/map.models';

@Component({
  selector: 'rlst-layers-legend-item',
  templateUrl: './layers-legend-item.component.html',
  styleUrls: ['./layers-legend-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LayersLegendItemComponent {
  @Input() layer: LayerInfo;
  @Output() closeLayer: EventEmitter<LayerInfo> = new EventEmitter();
}
